module.exports = {"370614001":"登州街道","370614002":"紫荆山街道","370614003":"新港街道","370614004":"蓬莱阁街道","370614005":"南王街道","370614006":"南长山街道","370614102":"刘家沟镇","370614103":"潮水镇","370614105":"大柳行镇","370614106":"小门家镇","370614107":"大辛店镇","370614108":"村里集镇","370614109":"北沟镇","370614110":"砣矶镇","370614201":"北长山乡","370614202":"黑山乡","370614203":"大钦岛乡","370614204":"小钦岛乡","370614205":"南隍城乡","370614206":"北隍城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370614.json
// module id = 1519
// module chunks = 0